import { render, staticRenderFns } from "./Delegate.vue?vue&type=template&id=1d02b25a&scoped=true&"
import script from "./Delegate.vue?vue&type=script&lang=js&"
export * from "./Delegate.vue?vue&type=script&lang=js&"
import style0 from "./Delegate.vue?vue&type=style&index=0&id=1d02b25a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d02b25a",
  null
  
)

export default component.exports